/**
 * A language's name in that same language ("English", "Español"), for a
 * language picker.
 *
 * Endonyms rather than catalog copy: a reader looking for their own language
 * must recognise it whatever language the page is currently in, so the label
 * does not vary with the UI locale — and `Intl.DisplayNames` already knows every
 * one of them, so none is hand-typed. Capitalised because several languages
 * (Spanish among them) write their own name in lower case, which reads as a
 * typo at the start of a menu item.
 *
 * @param tag - a BCP-47 tag: a UI locale (`es`) or a recording language (`es-US`).
 * @returns the endonym, with the region in brackets when the tag has one.
 */
export function languageEndonym(tag: string): string {
  const name =
    new Intl.DisplayNames([tag], { type: "language", languageDisplay: "standard" }).of(tag) ?? tag;
  return name.charAt(0).toLocaleUpperCase(tag) + name.slice(1);
}
